var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.286 4h9.143V2.857H2.286Zm0 19.429a2.2 2.2 0 0 1-1.614-.671A2.2 2.2 0 0 1 0 21.142V2.856a2.2 2.2 0 0 1 .671-1.614A2.2 2.2 0 0 1 2.286.571h9.143a2.2 2.2 0 0 1 1.614.671 2.2 2.2 0 0 1 .671 1.614v4.4a8.17 8.17 0 0 0-1.229.786 7.951 7.951 0 0 0-1.057.986V6.285H2.286v11.429h7.343a9.736 9.736 0 0 0 .529 1.2 7.26 7.26 0 0 0 .7 1.086H2.286v1.143h9.143v-.457a8.009 8.009 0 0 0 .914.886 6.845 6.845 0 0 0 1.057.714 2.509 2.509 0 0 1-.814.828 2.128 2.128 0 0 1-1.157.314Zm15.429-4.571a3.854 3.854 0 0 0 2.829-1.171 3.854 3.854 0 0 0 1.171-2.829 3.854 3.854 0 0 0-1.171-2.828 3.854 3.854 0 0 0-2.829-1.171 3.854 3.854 0 0 0-2.829 1.171 3.854 3.854 0 0 0-1.171 2.828 3.854 3.854 0 0 0 1.171 2.829 3.854 3.854 0 0 0 2.828 1.17Zm-2.857 4.571v-2.971a6.163 6.163 0 0 1-2.486-2.257 6.107 6.107 0 0 1-.943-3.343 6.106 6.106 0 0 1 .943-3.343 6.163 6.163 0 0 1 2.486-2.257V6.287h5.714v2.971a6.164 6.164 0 0 1 2.486 2.257 6.107 6.107 0 0 1 .943 3.343 6.107 6.107 0 0 1-.943 3.343 6.164 6.164 0 0 1-2.486 2.257v2.971ZM2.287 20Zm0-16Z",
    "data-name": "Group 53311"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.9dd0e2fe41d83a2c7916e97761d79d19.svg";
export { ForwardRef as ReactComponent };